import * as types from "../types";

// INITIAL TIMER STATE
const initialTimerState = {
    direction:localStorage.getItem("direction")||'rtl',
    sider_open:true,
    menuId:"",
    completeInfoModal:false,
    checkRiskModal:false,
   
};

// TIMER REDUCER
const PublicReducer = (state = initialTimerState, { type, payload }) => {
    switch (type) {
        case types.CHANGE_PUBLIC: {
            const { prop, value } = payload;
            return {
                ...state,
                [prop]: value,
            };
        }
        default:
            return state;
    }
};



export default PublicReducer;
